var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.actions),function(action,i){return [_c('v-btn',_vm._b({key:i,staticClass:"my-1 square-button",class:{ 'ml-1': i > 0 },attrs:{"small":"","text":"","elevation":"2","title":_vm.actionsData[action].hint},on:{"click":function($event){$event.stopPropagation();return _vm.triggerAction(action, _vm.item)}}},'v-btn',
        typeof _vm.actionsData[action].attrs === 'function'
          ? _vm.actionsData[action].attrs(_vm.item)
          : _vm.actionsData[action].attrs ?? {}
      ,false),[_c('v-icon',{attrs:{"color":_vm.actionsData[action].color}},[_vm._v(_vm._s(_vm.actionsData[action].icon))])],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }